// src/components/IDVerificationIndicator.tsx
import React, { useState } from "react";
import Modal from "react-modal";
import PatientIDVerificationDisplay from "./PatientIDVerificationDisplay";

// Ensure you've set Modal.setAppElement("#root") in your index.tsx

interface IDVerificationIndicatorProps {
  verified: boolean;
  idImageUrl?: string;
  selfieImageUrl?: string;
  similarity?: string;
}

const IDVerificationIndicator: React.FC<IDVerificationIndicatorProps> = ({
  verified,
  idImageUrl,
  selfieImageUrl,
  similarity,
}) => {
  const [showModal, setShowModal] = useState(false);
  console.log({ verified, idImageUrl, selfieImageUrl, similarity });
  return (
    <>
      <div
        className="id-verification-indicator"
        style={{
          justifyContent: "center",
          alignSelf: "center",
          alignItems: "center",
          alignContent: "center",
          cursor: verified ? "pointer" : "default",
          color: verified ? "green" : "red",
          fontWeight: "bold",
          textAlign: "center",
          border: "1px",
          borderStyle: "solid",
          width: "8rem",
          padding: ".5rem",
        }}
        onClick={() => {
          if (verified) setShowModal(true);
        }}
      >
        {verified ? "ID Verified" : "This patient is not ID verified"}
      </div>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        className="PatientIDVerificationDisplay"
      >
        <button onClick={() => setShowModal(false)} className="id-close-button">
          {" "}
          X
        </button>
        <PatientIDVerificationDisplay
          verification={{
            verified,
            idImageUrl,
            selfieImageUrl,
            similarity,
          }}
        />
      </Modal>
    </>
  );
};

export default IDVerificationIndicator;
